import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {CouponCode, CouponStatus} from '../__generated__/resolvers-types';

export const LIST_COUPON_CODES_QUERY = gql`
  query ListCouponCodes($offset: Float, $limit: Float, $status: CouponStatus) {
    listCouponCodes(offset: $offset, limit: $limit, status: $status) {
      id
      name
      status
      maxUses
      usedCount
      createdAt
      expiryDate
      durationDays
      couponRole
      createdBy
    }
  }
`;

export interface ListCouponCodesParams {
  offset?: number;
  limit?: number;
  status?: CouponStatus;
}

export function useListCouponCodes(params?: ListCouponCodesParams) {
  const {data, loading, error, refetch, fetchMore} = useQuery<{listCouponCodes: CouponCode[]}>(
    LIST_COUPON_CODES_QUERY,
    {
      variables: {
        offset: params?.offset || 0,
        limit: params?.limit || 20,
        status: params?.status,
      },
      fetchPolicy: 'network-only',
    },
  );

  const loadMore = async (newOffset: number) => {
    await fetchMore({
      variables: {
        offset: newOffset,
        limit: params?.limit || 20,
        status: params?.status,
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          listCouponCodes: [...prev.listCouponCodes, ...fetchMoreResult.listCouponCodes],
        };
      },
    });
  };

  return {
    data: data?.listCouponCodes || [],
    loading,
    error,
    refetch,
    loadMore,
  };
}
